import { WorkflowConsent } from '@shared/models';

/**
 * The errors after which a screen's consents must be fetched again: an expired token, or a consent still owed on
 * the landing page (KOR-15237) or the current step (KOR-15238).
 */
export const CONSENTS_REFRESH_CODES = ['presentation-token-invalid', 'landing-consents-required', 'step-consents-required'];

export const CONSENTS_BLOCKED = 'Tick all the required boxes to continue.';
export const CONSENTS_CHANGED = 'Some agreements changed. Please review and accept them again.';
export const CONSENTS_FAILED = "We couldn't save your agreement. Please try again.";

export const isConsentsRefreshError = (errorRes: unknown): boolean =>
  CONSENTS_REFRESH_CODES.includes((errorRes as { error?: { errorCode?: string } } | undefined)?.error?.errorCode ?? '');

/** A required consent isn't ticked yet. An optional one (e.g. SMS) never holds the screen back. */
export const requiredConsentsMissing = (consents: WorkflowConsent[], ticked: WorkflowConsent[]): boolean =>
  consents.some((consent) => consent.required !== false && !ticked.includes(consent));
